export default __webpack_public_path__ + "static/media/buroring-certs.85fc0683.png";